import gnm12b from './gnm12-b'
import gnm12d from './gnm12-d'
import gnm13 from './gnm13'
import gnm14 from './gnm14'
import cx005 from './cx005'

export const gnssProducts = {
  'gnm12-b': gnm12b,
  'gnm12-d': gnm12d,
  gnm13,
  gnm14,
  cx005
}
